import { render, staticRenderFns } from "./DomesticInquiryNew.vue?vue&type=template&id=5b3a1ab8"
import script from "./DomesticInquiryNew.vue?vue&type=script&lang=js"
export * from "./DomesticInquiryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports